import { lazy, useState, useEffect } from "react";
import PartDetils from "../pages/Frontend/shop/PartDetils.jsx";

import Wishlist from "../pages/Frontend/MyAccount/components/Wishlist.jsx";
import AuthPage from "../pages/Frontend/user_auth/login/AuthPage.js";
import EmailVerification from "../pages/Frontend/MyAccount/components/EmailVerification.jsx";
import CustomerAccountForm from "../pages/Frontend/MyAccount/components/CustomerAccountForm.jsx";
import Productpage from "../pages/ProductPage/Productpage.jsx";
import ServicePage from "../pages/Frontend/homePage/components/servicePage/ServicePage.jsx";
import OrderConfirmation from "../pages/Frontend/shop/OrderConfirmation.jsx";

// Lazy load components
import HomePage from "../pages/Frontend/homePage/HomePage";
import Signup from "../pages/Frontend/user_auth/signup/AdminSingIn.jsx";
import Login from "../../components/pages/Frontend/user_auth/login/Login";
// import MainBlog from "../pages/Frontend/blogPage/MainBlog.jsx";
// import PrivacyPolicy from "../pages/Frontend/PrivacyPolicy/PrivacyPolicy.jsx";
// import BookNow from "../pages/Frontend/homePage/components/bookNow/BookNow";
import Shop from "../pages/Frontend/shop/Shop.js";
// const OurServices = lazy(() => import("../pages/Frontend/services/OurServices.jsx"));
// const Clutch = lazy(() => import("../pages/Frontend/services/components/Clutch.jsx"));
// const Breaks = lazy(() => import("../pages/Frontend/services/components/Breaks.jsx"));
// const Electrical = lazy(() => import("../pages/Frontend/services/components/Electrical.jsx"));
// const EngineDiagnostics = lazy(() => import("../pages/Frontend/services/components/EngineDiagnostics.jsx"));
// const Exhaust = lazy(() => import("../pages/Frontend/services/components/Exhaust.jsx"));
// const Maintenance = lazy(() => import("../pages/Frontend/services/components/Maintenance.jsx"));
// const Radiators = lazy(() => import("../pages/Frontend/services/components/Radiators.jsx"));
// const Suspension_Steering = lazy(() => import("../pages/Frontend/services/components/Suspension_Steering.jsx"));
// const TransferCase = lazy(() => import("../pages/Frontend/services/components/TransferCase.jsx"));
// const Fuel = lazy(() => import("../pages/Frontend/services/components/Fuel.jsx"));
import ContactUs from "../pages/Frontend/contactus/ContactUs.jsx";
import About from "../pages/Frontend/aboutus/About.jsx";
import Flipbook from "../pages/Frontend/homePage/components/flipbook/flipbook.jsx";
import AddtoCart from "../pages/Frontend/shop/AddtoCart.jsx";
// import SingleBlogPage from "../pages/Frontend/blogPage/SingleBlogPage.jsx";
import Cart from "../pages/Frontend/shop/Cart.jsx";
import OtpPage from "../pages/Frontend/user_auth/login/OtpPage.jsx";
import CheckoutPage from "../pages/Frontend/shop/CheckoutPage.jsx";
// import FaqPage from "../pages/Frontend/FAQ/FaqPage.jsx";

// const BulkyOrderList = lazy(() => import("../pages/AdminPannel/order/BulkyOrderList.jsx"));
const NotFoundpage = lazy(
  () => import("../defaultStructure/notFoundPage/NotFoundpage.jsx"),
);
const PaymentSuccess = lazy(
  () => import("../pages/Frontend/shop/PaymentSuccess.jsx"),
);

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/", exact: true, name: "HomePage" },
  { path: "/homepage", element: HomePage },

  { path: "/login", element: AuthPage },
  // { path: "/blog/:categoryName?", element: MainBlog },
  // { path: "/blog/post/:id", element: SingleBlogPage },
  // { path: "/blog/single-blog/:id", element: SingleBlogPage },
  // { path: "/book-now", element: BookNow },
  { path: "/shop", element: Shop },
  // { path: "/privacy-policy", element: PrivacyPolicy },
  { path: "/shop/vehicles/:makes?/:model?/:year?/:category?", element: Shop },

  { path: "/contact-us", element: ContactUs },
  { path: "/about-us", element: About },
  { path: "/flipbook", element: Flipbook },
  { path: "/shop/single-product/:id", element: AddtoCart }, // this is for the add to cart button redirect the page
  { path: "/addtocart", element: Cart },
  { path: "/singup-otp/:email", element: OtpPage },
  // { path: "/faq", element: FaqPage },
  { path: "/shop/checkouts", element: CheckoutPage },
  { path: "/payment-success", element: PaymentSuccess },
  // { path: "/partdetails", element: PartDetils }, // this is for the part detils page

  { path: "/wishlist", element: Wishlist },

  { path: "/email-verify", element: EmailVerification },
  { path: "/account", element: CustomerAccountForm },

  // { path: "/admin/bulky-order-list", element: BulkyOrderList },
  { path: "/productpage", element: Productpage },
  { path: "/services", element: ServicePage },
  { path: "/orderconfirm", element: OrderConfirmation },

  { path: "*", element: NotFoundpage },

  // {path:""}
];
export default routes;
